import React from "react";
import type { KgDescriptionIconProps } from "./KgDescriptionIcon.types";

/** Description / text-lines icon for ontology inspector overview. */
export const KgDescriptionIcon: React.FC<KgDescriptionIconProps> = ({
  size = 16,
  className,
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    aria-hidden
    className={className}
  >
    <path
      d="M11.3333 4.06641H2"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M14 8.06641H2"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.0667 12H2"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default KgDescriptionIcon;
